import { combineReducers } from 'redux';
import patternCategoriesReducer from './patternCategoriesReducer';
import patternsReducer from './patternsReducer';
import patternCategoryAssignmentsReducer from './patternCategoryAssignmentsReducer';

export default combineReducers({
  patternCategories: patternCategoriesReducer,
  patternCategoryAssignments: patternCategoryAssignmentsReducer,
  patterns: patternsReducer
});